import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';

export function useStepCardDnD(stepId?: string, disabled: boolean = false) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: String(stepId ?? ''), disabled: disabled });

  const dragStyle: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
    opacity: isDragging ? 0.6 : 1,
  };

  return { attributes, listeners, setNodeRef, setActivatorNodeRef, dragStyle, isDragging };
}
